import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Home } from './pages/Home';
import { Work } from './pages/Work';
import { CreativeDirection } from './pages/CreativeDirection';
import { Architecture } from './pages/Architecture';
import { UXUIDesign } from './pages/UXUIDesign';
import { Art } from './pages/Art';
import { AleksandroNevsky } from './pages/AleksandroNevsky';
import { BioMaxing } from './pages/BioMaxing';
import { CoLab } from './pages/CoLab';
import { TransformerTheatre } from './pages/TransformerTheatre';
import { Fizkultura } from './pages/Fizkultura';
import { MariinskyTheatre } from './pages/MariinskyTheatre';
import { CoLiving } from './pages/CoLiving';
import { ANMWebsite } from './pages/ANMWebsite';
import { Expressive } from './pages/Expressive';
import { Commission } from './pages/Commission';
import { Academic } from './pages/Academic';
import { Sketching } from './pages/Sketching';
import { BrandingMarketing } from './pages/BrandingMarketing';
import { ProjectManagement } from './pages/ProjectManagement';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
        <Route path="/work" element={<Work data-id="element-6" />} data-id="element-5" />
        <Route path="/creative-direction" element={<CreativeDirection data-id="element-8" />} data-id="element-7" />
        <Route path="/architecture" element={<Architecture data-id="element-10" />} data-id="element-9" />
        <Route path="/ux-ui-design" element={<UXUIDesign data-id="element-12" />} data-id="element-11" />
        <Route path="/art" element={<Art data-id="element-14" />} data-id="element-13" />
        <Route path="/branding-marketing" element={<BrandingMarketing data-id="element-16" />} data-id="element-15" />
        <Route path="/project-management" element={<ProjectManagement data-id="element-18" />} data-id="element-17" />
        <Route path="/projects/aleksandro-nevsky" element={<AleksandroNevsky data-id="element-20" />} data-id="element-19" />
        <Route path="/projects/biomaxing" element={<BioMaxing data-id="element-22" />} data-id="element-21" />
        <Route path="/projects/co-lab" element={<CoLab data-id="element-24" />} data-id="element-23" />
        <Route path="/projects/transformer-theatre" element={<TransformerTheatre data-id="element-26" />} data-id="element-25" />
        <Route path="/projects/fizkultura" element={<Fizkultura data-id="element-28" />} data-id="element-27" />
        <Route path="/projects/mariinsky-theatre" element={<MariinskyTheatre data-id="element-30" />} data-id="element-29" />
        <Route path="/projects/co-living" element={<CoLiving data-id="element-32" />} data-id="element-31" />
        <Route path="/projects/anm-website" element={<ANMWebsite data-id="element-34" />} data-id="element-33" />
        <Route path="/projects/expressive" element={<Expressive data-id="element-36" />} data-id="element-35" />
        <Route path="/projects/commission" element={<Commission data-id="element-38" />} data-id="element-37" />
        <Route path="/projects/academic" element={<Academic data-id="element-40" />} data-id="element-39" />
        <Route path="/projects/sketching" element={<Sketching data-id="element-42" />} data-id="element-41" />
      </Routes>
    </BrowserRouter>;
}